'use client'
import { reservationService } from '@/root/shared-api'
import useSWR from 'swr'
import { Reservation } from '@/root/shared-types'
import { useCustomRouter } from '@/root/shared-hooks'

const immutableConfig = {
  revalidateIfStale: false,
  revalidateOnFocus: false,
  revalidateOnReconnect: false,
}

interface UseReservationOptions {
  revalidate?: boolean
}

export function useReservation({ revalidate = false }: UseReservationOptions = {}) {
  const {
    query: { reservationToken },
    isReady,
    locale,
  } = useCustomRouter()

  const { data, error, isLoading, isValidating } = useSWR<Reservation>(
    isReady && `/reservation/${reservationToken}/${locale}`,
    () => reservationService.getReservation(reservationToken as string, locale),
    revalidate ? undefined : immutableConfig
  )

  return {
    reservation: data,
    error,
    isLoading,
    isValidating,
  }
}
